import { ActiveSectionProvider } from '../../components/Profile/ActiveSectionContext';
import ProfileContainer from '../../components/Profile/ProfileContainer';

const Profile = () => {
  return (
    <ActiveSectionProvider>
      <ProfileContainer />
    </ActiveSectionProvider>
  );
};

export default Profile;
